<!--
 * @Description: 编辑页
-->
<template>
  <div class="page">
    <div>
      <el-form label-width="auto" :model="addForm" ref="ruleForm">
        <el-form-item label="产品标题">
          <el-input v-model="addForm.title" placeholder="产品标题"></el-input>
        </el-form-item>

        <el-form-item label="产品名称">
          <el-input v-model="addForm.name" placeholder="产品名称"></el-input>
        </el-form-item>

        <el-form-item label="价格">
          <el-input v-model="addForm.price" placeholder="价格"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="addForm.integral" placeholder="积分"></el-input>
        </el-form-item>

        <el-form-item label="运费">
          <el-input v-model="addForm.freight" placeholder="运费"></el-input>
        </el-form-item>

        <el-form-item label="库存">
          <el-input v-model="addForm.stock" placeholder="库存"></el-input>
        </el-form-item>

        <el-form-item label="限购">
          <el-input v-model="addForm.maxCount" placeholder="限购"></el-input>
        </el-form-item>

        <el-form-item label="兑换">
          <el-switch
            v-model="addForm.isIntegral"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>

          <span style="margin-left: 10px">(是否可以使用积分单独兑换)</span>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage"
            multiple
            accept="image"
            :limit="9"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch
            v-model="addForm.status"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>

        <el-form-item label="详情">
          <Tinymce v-model="addForm.content" @tinymceId="getTinymceId" @eventTinymce="eventTinymce" />
        </el-form-item>
      </el-form>
    </div>

    <FixedActionBar>
      <el-button type="primary" @click="onEstablish()">确 定</el-button>
      <el-button @click="$router.go(-1)">取消</el-button>
    </FixedActionBar>

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 0新增， 1编辑
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tinymceId: null,

      addForm: {
        id: 0,
        categorize: 2,
        name: '',
        title: '',
        price: '',
        integral: '',
        freight: '',
        stock: 0,
        maxCount: 0,
        isIntegral: 1,
        ImgUrl: '',
        content: '',
        status: 1
      },

      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  created() {
    const { id } = this.$route.query
    if (id) this.getInfo(id)
  },

  computed: {
    myImage: function () {
      const arr = []
      if (this.addForm.ImgUrl) {
        const list = this.addForm.ImgUrl.split(',')
        list.forEach((item) => {
          if (item) {
            arr.push({
              url: item
            })
          }
        })
      }
      return arr
    }
  },

  methods: {
    // 编辑器id
    getTinymceId(e) {
      console.log(e)
      this.tinymceId = e
    },
    // 编辑器内容
    eventTinymce(e) {
      // console.log(e)
      this.addForm.Content = e
      this.addForm.content = e
    },

    async getInfo(Id) {
      try {
        const { data } = await this.$api.integral.get({
          Id
        })
        console.log('getInfo', data)

        this.addForm = {
          id: data.ProductId,
          categorize: 2,
          name: data.Name,
          title: data.Title,
          price: data.Price,
          integral: data.Integral,
          freight: data.Freight,
          stock: data.Stock,
          maxCount: data.MaxCount,
          isIntegral: data.IsIntegral,
          ImgUrl: data.ImgUrl,
          content: data.Content,
          status: data.Status
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 创建/编辑
    async onEstablish() {
      this.addForm.imgUrl = this.$refs.upload.uploadFiles
        .map((item) => {
          return item.url.startsWith('http') ? item.url : item.response.data
        })
        .join(',')
      console.log('form', this.addForm, this.$refs.upload.uploadFiles)

      let msg = '操作成功'
      try {
        const { data } = await this.$api.integral.add(this.addForm)
        console.log('添加产品', data)
      } catch (error) {
        msg = '操作失败'
      }

      this.$message.success(msg)
      this.$router.go(-1)
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-bottom: 90px;
}
</style>
